import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { action_setFilterContractList, action_setFilterIndexList } from '../../../reducers/actions/Adjustment/actions';
import { getAdjustmentIndexFilters } from '../../../services/sAdjustment/filters.service';
import { getAllContracts } from '../../../services/sBook/contract.service';


const useGetAdjustmentContractList = (listContract) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getAllContracts();

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_setFilterContractList(response))
                }
                else {
                    dispatch(action_setFilterContractList([]))
                }
            }
            catch (error) {
                dispatch(action_setFilterContractList([]))
            }
        }
        
        if (listContract === null) {
            doIt()
        }
    }, [listContract]);
}

const useGetAdjustmentIndexList = (listIndex) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getAdjustmentIndexFilters();

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_setFilterIndexList(response))
                }
                else {
                    dispatch(action_setFilterIndexList([]))
                }
            }
            catch (error) {
                dispatch(action_setFilterIndexList([]))
            }
        }
        
        if (listIndex === null) {
            doIt()
        }
    }, [listIndex]);
}

export {
    useGetAdjustmentContractList,
    useGetAdjustmentIndexList,
}